export class Globals {
	public static BASE_URL: string = 'https://reports.qf.org.qa/2022-year-in-review';
	public static CURRENT_LANGUAGE_PREFIX: string = 'en';
	public static SITE_FIRST_LOAD: boolean = true;
}